import { createFileRoute } from "@tanstack/react-router";
import { redirectTo } from "@/lib/route-redirect";
export const Route = createFileRoute("/hosting/reseller-hosting")({ beforeLoad: redirectTo("/hosting/web/reseller-hosting") });
